import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportHeader from "../../../../common/ReportHeader";
import { otherReportMenu, reportMenu } from "../../../../../redux/Actions";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from "../../../../generics/helper";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { callAddFontRobotoNormal } from "../../../../../assets/fonts/Roboto-normal";
import { callAddFontRobotoBold } from "../../../../../assets/fonts/Roboto-bold";
import { focusElemnt } from "../../../../../utilityFunctions";

const MonthlyPassTable = ({ data = [], filterValue = {}, handleBack }) => {
	const dispatch = useDispatch();
	const LoginId = sessionStorage.getItem("LoginId");
	const user = useSelector((store) => store.user);
	 const headerData = [
          { headerName: `From Date : ${moment(filterValue?.fromDate).format('DD-MMM-YYYY')}`, value: `To Date : ${moment(filterValue?.toDate).format('DD-MMM-YYYY')}` },
          { headerName: `User:${user?.UserName} (${LoginId}) `, value: '' },
          { headerName: 'Corporation', value: `${filterValue?.corporation.length > 1 ? 'All' : filterValue?.corporation[0]?.CorporationCode}` },
          { headerName: `Print Date & Time:${moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')}`, value: '' },
          { headerName: 'Division', value: `${filterValue?.division.length > 1 ? 'All' : filterValue?.division[0]?.DivisionCode}` },
          { headerName: 'Concession', value: `${filterValue?.concession?.length > 1 ? 'All' : filterValue?.concession?.[0]?.ConcessionName || 'All'}` },
          { headerName: 'Bus Type', value: `${filterValue?.busType?.length > 1 ? 'All' : filterValue?.busType?.[0]?.BusTypeName || 'All'}` },
      ]
      const columnDefs = [
          { headerName: 'S. No.', exportHead: 'S. No.', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }, showFilter: true },
          { headerName: 'Created Date', exportHead: 'Created Date', field: 'CreatedDate', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'MPNR No.', exportHead: 'MPNR No.', field: 'MPNRNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Pass No.', exportHead: 'Pass No.', field: 'PassNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Pass Issued On', exportHead: 'Pass Issued On', field: 'PassIssuedOn', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Corporation', exportHead: 'Corporation', field: 'Corporation', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Division', exportHead: 'Division', field: 'Division', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'From Palce', exportHead: 'From Palce', field: 'FromPalce', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'To Place', exportHead: 'To Place', field: 'ToPlace', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Name', exportHead: 'Name', field: 'Name', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Gender', exportHead: 'Gender', field: 'Gender', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Age', exportHead: 'Age', field: 'Age', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Concession', exportHead: 'Concession', field: 'Concession', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Bus Type', exportHead: 'Bus Type', field: 'BusType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
      ];
      // const tableData = [
      //      { id: 1, CreatedDate: "11-05-2026  3:17:00 PM", MPNRNo: "MPNR00000001", PassNo: "MP00000076", PassIssuedOn: "16-04-2026", Corporation: "", Division: "", FromPalce: "HAVERI", ToPlace: "LAXMESHWAR", Name: "Sheetal Kumar", Gender: "Male", Age: "34", Concession: "General Concession", BusType: "Ordinary Service",},
      // ]
	useEffect(() => {
		focusElemnt("printButton");
	}, []);

	// for Export as Pdf and Print
	const printReport = (param = "pdf") => {
		try {
			const cancellationColumns = columnDefs.map((col) => {
				return {
					header: col.exportHead,
					dataKey: col.field,
					xlCol: col.xlCol,
				};
			});

			jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
			jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

			const doc = new jsPDF({
				orientation: "l",
				format: "a4",
			});

			var totalPagesExp = "{total_pages_count_string}";
			doc.autoTableSetDefaults({
				headStyles: {
					fontSize: 8,
					halign: "left",
					fillColor: [30, 89, 167],
				},
			});

			const pageWidth = doc.internal.pageSize.width; // Get the page width
			const startY = 10;

			// Add the text at the top of the page
			doc.setFontSize(14);
			doc.setTextColor("#000000");
			doc.setFont("Roboto", "bold");

			const title = "KARNATAKA STATE ROAD TRANSPORT CORPORATION";
			const titleWidth = doc.getTextWidth(title);
			doc.text(title, (pageWidth - titleWidth) / 2, startY); // Center align

			doc.setFont("Roboto", "normal");
			doc.setFontSize(10);

			const subTitle = "Monthly Pass Report";
			const subTitleWidth = doc.getTextWidth(subTitle);
			doc.text(subTitle, (pageWidth - subTitleWidth) / 2, startY + 8); // Center align

			doc.setFontSize(10);
			doc.setTextColor("#000000");
			doc.text(
				`From Date: ${moment(filterValue.fromDate).format("DD-MMM-YYYY")} - To Date: ${moment(filterValue.toDate).format("DD-MMM-YYYY")}`,
				5,
				startY + 14,
			);
			doc.text(
				`User: ${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""})`,
				doc.internal.pageSize.width - 5,
				startY + 14,
				"right",
			);
			doc.text(
				`Division: ${filterValue?.division.length > 1 ? "All" : filterValue?.division[0]?.DivisionCode}`,
				5,
				startY + 20,
			);
			doc.text(
				`Print Date & Time : ${moment(window.getTime ? window.getTime() : new Date()).format("DD-MMM-YYYY HH:mm")}`,
				doc.internal.pageSize.width - 5,
				startY + 20,
				"right",
			);
			doc.text(
				`Corporation: ${filterValue?.corporation.length > 1 ? "All" : filterValue?.corporation[0]?.CorporationCode}`,
				5,
				startY + 26,
			);
			doc.text(
				`Concession: ${filterValue?.concession?.length > 1 ? "All" : filterValue?.concession?.[0]?.ConcessionName || "All"}`,
				5,
				startY + 32,
			);
			doc.text(
				`Bus Type: ${filterValue?.busType?.length > 1 ? "All" : filterValue?.busType?.[0]?.BusTypeName || "All"}`,
				5,
				startY + 38,
			);

			// Print the table on the first page
			autoTable(doc, {
				startY: 50,
				margin: { top: 3, left: 5, right: 5, bottom: 3 },
				tableWidth: "auto",
				columns: cancellationColumns,
				body: data,
				columnStyles: {
					0: { halign: "left", fontSize: 7 },
					1: { halign: "left", fontSize: 7 },
					2: { halign: "left", fontSize: 7 },
					3: { halign: "left", fontSize: 7 },
					4: { halign: "left", fontSize: 7 },
					5: { halign: "left", fontSize: 7 },
					6: { halign: "left", fontSize: 7 },
					7: { halign: "left", fontSize: 7 },
					8: { halign: "left", fontSize: 7 },
					9: { halign: "left", fontSize: 7 },
					10: { halign: "left", fontSize: 7 },
					11: { halign: "left", fontSize: 7 },
					12: { halign: "left", fontSize: 7 },
					13: { halign: "left", fontSize: 7 },
				},
				theme: "grid",
				headStyles: {
					fillColor: null,
					textColor: [0, 0, 0],
					lineWidth: 0.2,
				},
				didParseCell: (data) => {
					jsPdfDidParseCellCallback(data, cancellationColumns, []);
				},
				willDrawCell: (data) => {
					jsPdfWillDrawCellCallback(data, true);
				},
				didDrawPage: function (data) {
					data.settings.margin.top = 16;
				},
				pageBreak: "auto",
			});
			if (typeof doc.putTotalPages === "function") {
				doc.putTotalPages(totalPagesExp);
			}

			if (param === "print") {
				const pdfBlob = new Blob([doc.output("blob")], {
					type: "application/pdf",
				});
				const pdfUrl = URL.createObjectURL(pdfBlob);
				window.open(pdfUrl);
			} else {
				const pdfData = doc.output("blob");
				const pdfUrl = URL.createObjectURL(pdfData);
				const link = document.createElement("a");
				link.href = pdfUrl;
				link.download = "Monthly_Pass.pdf";
				link.click();
			}
		} catch (error) {
			console.log("Error: ", error);
		}
	};

	const CommonReportHeader = (props) => {
		const { reportName, subHeader = "", headerData } = props;
		return (
			<>
				<Box sx={{ textAlign: "center" }}>
					<div className="main_heading">
						KARNATAKA STATE ROAD TRANSPORT CORPORATION
					</div>
					<div className="sub_heading1">
						{reportName.toUpperCase()}
					</div>
					{subHeader !== "" ? (
						<div className="sub_heading1">
							{subHeader.toUpperCase()}
						</div>
					) : (
						""
					)}
				</Box>
				<Box sx={{ display: "flex", flexDirection: "column" }}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: "20px",
						}}
					>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[0].headerName}
							</span>
							<span style={{ padding: "0px 2px" }}> -</span>
							<span className="sub_heading2">
								{headerData[0].value}{" "}
							</span>
						</div>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[1].headerName}
							</span>
							<span className="sub_heading2">
								{headerData[1].value}{" "}
							</span>
						</div>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: "20px",
						}}
					>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[2].headerName}
							</span>
							<span style={{ padding: "0px 2px" }}>:</span>
							<span className="sub_heading2">
								{headerData[2].value}{" "}
							</span>
						</div>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[3].headerName}
							</span>
							<span className="sub_heading2">
								{headerData[3].value}{" "}
							</span>
						</div>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: "20px",
						}}
					>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[4].headerName}
							</span>
							<span style={{ padding: "0px 2px" }}>:</span>
							<span className="sub_heading2">
								{headerData[4].value}{" "}
							</span>
						</div>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">{headerData[5].headerName}</span>
							<span style={{ padding: "0px 2px" }}>:</span>
							<span className="sub_heading2">{headerData[5].value}{" "}</span>
						</div>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: "20px",
						}}
					>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[6].headerName}
							</span>
							<span style={{ padding: "0px 2px" }}>:</span>
							<span className="sub_heading2">
								{headerData[6].value}{" "}
							</span>
						</div>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2"></span>
							<span className="sub_heading2"></span>
						</div>
					</Box>
					{/* <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: "20px",
						}}
					>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2">
								{headerData[6].headerName}
							</span>
							<span style={{ padding: "0px 2px" }}>:</span>
							<span className="sub_heading2">
								{headerData[6].value}{" "}
							</span>
						</div>
						<div style={{ textAlign: "left" }}>
							<span className="sub_heading2"></span>
							<span className="sub_heading2"></span>
						</div>
					</Box> */}
				</Box>
			</>
		);
	};
	const InsideRowContent = ({ item, index, fontVal }) => {
		return (
			<>
				{item.isDataRow && (
					<TableRow key={index}>
						<>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.SN}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.CreatedDate}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.MPNRNo}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.PassNo}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.PassIssuedOn}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Corporation}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Division}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.FromPalce}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.ToPlace}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Name}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Gender}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Age}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.Concession}
							</TableCell>
							<TableCell
								className="reportTD"
								colSpan={1}
								style={{
									background: "F5FAFE",
									fontSize: fontVal,
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								{item.BusType}
							</TableCell>
						</>
					</TableRow>
				)}
			</>
		);
	};
	return (
		<>
			<ReportHeader
				mainHeaderName="Report"
				headerName="Other Report"
				openSubMenu={() => dispatch(reportMenu(true))}
				subHeader={"Monthly Pass Report"}
				subHeaderVisible={() => dispatch(otherReportMenu(true))}
			/>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					padding: "16px 0px 16px 0px",
					justifyContent: "center",
					alignItems: "center",
					gap: "10px",
					height: "76px",
				}}
			>
				<div style={{ position: "relative" }}>
					<Button
						startIcon={
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g mask="url(#mask0_781_30893)">
									<path
										d="M18 7H6V3H18V7ZM18 12.5C18.2833 12.5 18.5208 12.4042 18.7125 12.2125C18.9042 12.0208 19 11.7833 19 11.5C19 11.2167 18.9042 10.9792 18.7125 10.7875C18.5208 10.5958 18.2833 10.5 18 10.5C17.7167 10.5 17.4792 10.5958 17.2875 10.7875C17.0958 10.9792 17 11.2167 17 11.5C17 11.7833 17.0958 12.0208 17.2875 12.2125C17.4792 12.4042 17.7167 12.5 18 12.5ZM16 19V15H8V19H16ZM18 21H6V17H2V11C2 10.15 2.29167 9.4375 2.875 8.8625C3.45833 8.2875 4.16667 8 5 8H19C19.85 8 20.5625 8.2875 21.1375 8.8625C21.7125 9.4375 22 10.15 22 11V17H18V21Z"
										fill="white"
									/>
								</g>
							</svg>
						}
						variant="contained"
						size="medium"
						id="printButton"
						className={`btn-orange`}
						onClick={() => printReport("print")}
						// onKeyDown={(e) =>
						// 	navigation3(e, "expPdfButton", " ", () => {
						// 		printReport("print");
						// 	})
						// }
					>
						Print
					</Button>
				</div>
				<div>
					<Button
						startIcon={
							<svg
								width="13"
								height="16"
								viewBox="0 0 13 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M10.0361 4.50132C9.17024 4.50132 8.47694 3.80881 8.47694 2.9507V0H1.50769C1.102 0 0.729623 0.150546 0.442012 0.439594C0.151374 0.72563 0 1.09597 0 1.49944V14.5006C0 15.3256 0.678156 16 1.50769 16H11.4923C12.3218 16 13 15.3256 13 14.5006V4.50132H10.0361ZM10.0876 10.7249C9.85142 10.9597 9.52748 11.0952 9.20657 11.0952C8.73125 11.0952 8.17117 10.8242 7.54448 10.3184C7.24407 10.3771 6.91751 10.4641 6.53956 10.5649L6.39101 10.6044C6.07264 10.692 5.78967 10.7905 5.53455 10.8793L5.53454 10.8793L5.40708 10.9236C4.89846 11.8329 4.23847 12.7603 3.60876 12.9138C3.54215 12.9319 3.47252 12.9469 3.40592 12.9469C3.23638 12.9469 3.085 12.8957 2.94877 12.7783C2.72776 12.5916 2.62785 12.3387 2.67629 12.0708C2.81253 11.3782 3.92967 10.7881 4.9469 10.3846C5.07655 10.144 5.18975 9.8869 5.30216 9.63165L5.30217 9.63163L5.31928 9.59277C5.52212 9.08694 5.69166 8.63229 5.80973 8.24388C5.33442 7.36771 4.94388 6.28679 5.21635 5.69665C5.35258 5.41061 5.60689 5.242 5.94597 5.242C6.25175 5.242 6.48789 5.35943 6.64229 5.59729C6.94807 6.03688 6.8966 6.89499 6.52422 8.17764C6.69376 8.46368 6.88146 8.73466 7.051 8.91833C7.28714 9.17125 7.52632 9.4061 7.74732 9.59277C9.10363 9.35792 10.0028 9.45728 10.2722 9.89688L10.2784 9.9139C10.3224 10.033 10.4414 10.3558 10.0876 10.7249ZM12.7688 3.37228H10.038C9.8019 3.37228 9.6142 3.1856 9.61722 2.93569V0.237915C9.72016 0.304155 9.80493 0.373406 9.87153 0.439646L12.566 3.11936C12.6508 3.20367 12.7174 3.28797 12.7688 3.37228ZM5.92061 5.90137C6.02052 5.90137 6.05382 5.93449 6.07199 5.96761C6.19006 6.13622 6.20822 6.55775 6.05685 7.26832C5.82071 6.7113 5.69961 6.1874 5.80254 5.95255C5.80254 5.93449 5.82071 5.90137 5.92061 5.90137ZM6.10893 9.34174C6.15324 9.22081 6.19647 9.10283 6.24025 8.98758L6.29166 9.05331C6.38839 9.17717 6.4738 9.28654 6.54603 9.36093L6.59343 9.41345C6.7103 9.54312 6.81637 9.66079 6.93657 9.76439C6.71557 9.83064 6.46126 9.89989 6.20695 9.96613L6.17812 9.9742L6.17812 9.9742L6.1781 9.97421C6.06901 10.0047 5.95548 10.0365 5.81641 10.0836C5.83047 10.0509 5.84408 10.021 5.85741 9.99168C5.87852 9.94526 5.89893 9.90037 5.91934 9.8487C5.98719 9.67395 6.04904 9.50516 6.10891 9.34177L6.10892 9.34176L6.10893 9.34174ZM3.30469 12.2062C3.35615 12.2905 3.37129 12.2905 3.42276 12.2905C3.6589 12.2243 3.99798 11.8871 4.33706 11.3812C3.66193 11.7184 3.33799 12.0376 3.30469 12.2062ZM9.21996 10.4208C8.99895 10.4208 8.74464 10.3184 8.45703 10.1498C9.27142 10.0655 9.71344 10.1167 9.62564 10.2522C9.54087 10.3877 9.40766 10.4389 9.21996 10.4208Z"
									fill="white"
								/>
							</svg>
						}
						variant="contained"
						size="medium"
						id="expPdfButton"
						className={`btn-orange`}
						onClick={() => printReport("pdf")}
						// onKeyDown={(e) =>
						// 	navigation3(e, "backButton", "printButton", () => {
						// 		printReport("pdf");
						// 	})
						// }
					>
						Export As Pdf
					</Button>
				</div>
				<div>
					<Button
						variant="outlined"
						size="medium"
						id="backButton"
						className={`btn-orange-outline`}
						// onClick={() => handleBack()}
						onClick={handleBack}
						// onKeyDown={(e) =>
						// 	navigation3(e, "", "expPdfButton", () => {
						// 		handleBack();
						// 	})
						// }
					>
						Back
					</Button>
				</div>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					top: "104px",
					left: "60",
					padding: "0px 16px 60px 16px",
					gap: "16px",
				}}
			>
				<CommonReportHeader
					subHeader={""}
					reportName={"Monthly Pass Report"}
					headerData={headerData}
				/>

				<Box sx={{ padding: "0px" }}>
					<TableContainer
						className="scrollBlue"
						component={Paper}
						sx={{
							marginBottom: "5px",
							border: "1px solid #000000",
						}}
					>
						<Table
							stickyHeader
							aria-label="a dense table"
							sx={{
								"& .MuiTableCell-root": {
									padding: "6px 8px !important",
								},
							}}
						>
							<TableHead
								style={{
									position: `sticky`,
									top: `0`,
									zIndex: 2,
								}}
							>
								<TableRow>
									{columnDefs?.map((col, index) => (
										<TableCell
											key={`THR-${index}`}
											sx={{
												...col.headerSx,
												height: "44px",
												color: "#000000",
												fontSize: "12px",
												fontWeight: "600",
												//textAlign: index == 0 || index == 1 ? "left" : "right",
												borderBottom:
													"1px solid #000000",
											}}
										>
											{col.headerName}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							{data?.length < 1 ? (
								<>
									<TableBody>
										<TableRow>
											<TableCell colSpan={14}>
												<div
													style={{
														display: "flex",
														justifyContent:
															"center",
														marginTop: "20px",
														marginBottom: "20px",
														color: "red",
														fontSize: "12px",
														lineheight: "16px",
														letterspacing: "0.24px",
													}}
												>
													<span>
														No results found. Please
														refine your search
														parameters and search
														again.
													</span>
												</div>
											</TableCell>
										</TableRow>
									</TableBody>
								</>
							) : data?.length >= 1 ? (
								<TableBody
									style={{
										textAlign: "center",
										fontSize: "12px",
										lineheight: "16px",
										letterspacing: "0.24px",
										fontWeight: "500",
										marginLeft: "5px",
									}}
								>
									{data?.map((item, index) => (
										<InsideRowContent
											item={item}
											index={index}
											key={index}
											fontVal={"12px"}
										/>
									))}
								</TableBody>
							) : (
								""
							)}
						</Table>
					</TableContainer>
				</Box>
			</Box>
		</>
	);
};

export default MonthlyPassTable;
